import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: any) => ({
  selectBorder: {
    '&:before': {
      borderColor: '#E0E0E0',
    },
    '&:after': {
      borderColor: '#42A5F5',
    },
    color: 'black'

  },
  overlay: {
    background: '#e9e9e9',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    opacity: 0.5,
    zIndex: 998
  },
  tableContainer: {
    borderCollapse: 'collapse',
    width: '100%',
  },
  tableCellClassLeft: {
    border: '1px solid #dddddd',
    textAlign: "left",
    padding: "8px",
    fontSize: "10px",
    fontWeight: "600"
  },
  tableCellClassRight: {
    border: '1px solid #dddddd',
    textAlign: "center",
    padding: "8px",
    fontSize: "10px",
    fontWeight: "600"
  },
  loader: {
    position: 'absolute',
    border: '4px solid #f3f3f3',
    borderRadius: '50%',
    borderTop: '4px solid #eb0a1e',
    borderBottom: '4px solid #eb0a1e',
    borderLeft: '4px solid #eb0a1e',
    width: '120px',
    height: '120px',
    top: '45%',
    left: '50%',
    transform: `translate(-50%, -50%)`,
    webkitAnimation: '$spin 2s linear infinite',
    animation: '$spin 2s linear infinite'
  },


  "@-webkit-keyframes spin": {
    '0%': { "-webkit-transform": 'rotate(0deg)' },
    '100%': { "-webkit-transform": 'rotate(360deg)' }
  },


  "@keyframes spin": {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' }
  },
}));



